import { DriveStep } from "driver.js";

import { getCommonFinalSteps } from "./commonSteps";

export const getFootprintTourSteps = (
  t: (key: string) => string
): DriveStep[] => [
  {
    element: '[data-tour="footprint-page-header"]',
    popover: {
      title: t("tour.footprint.pageHeader.title"),
      description: t("tour.footprint.pageHeader.description"),
      side: "bottom",
      align: "start",
    },
  },
  {
    element: '[data-tour="footprint-create-button"]',
    popover: {
      title: t("tour.footprint.createButton.title"),
      description: t("tour.footprint.createButton.description"),
      side: "bottom",
      align: "end",
    },
  },
  {
    element: '[data-tour="footprint-projects-list"]',
    popover: {
      title: t("tour.footprint.projectsList.title"),
      description: t("tour.footprint.projectsList.description"),
      side: "right",
      align: "start",
    },
  },
  {
    element: '[data-tour="footprint-ask-sam"]',
    popover: {
      title: t("tour.footprint.askSam.title"),
      description: t("tour.footprint.askSam.description"),
      side: "left",
      align: "start",
    },
  },
  ...getCommonFinalSteps(t),
];

export const footprintTourConfig = {
  id: "footprint" as const,
  steps: getFootprintTourSteps,
};
